module.exports = __webpack_public_path__ + "static/media/icon-return.b711e31d.svg";